import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const workflowService = {
  getApprovals: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}approval/getApprovals`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },
  getEntraPendingRequests: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}entra/getPendingRequests`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },
  getApplicationRetirementPendingRequests: async (formObject) => {
    try {
      const params = new URLSearchParams();
      if (formObject?.pagination?.page !== undefined) params.append('page', formObject.pagination.page);
      if (formObject?.pagination?.pageSize !== undefined) params.append('pageSize', formObject.pagination.pageSize);
      if (formObject?.searchFilter) params.append('searchFilter', formObject.searchFilter);
      if (formObject?.dateFilter?.startDate) params.append('startDate', formObject.dateFilter.startDate);
      if (formObject?.dateFilter?.endDate) params.append('endDate', formObject.dateFilter.endDate);
      const response = await axios.get(`${API_ENDPOINT}application-retirement/approvals/pending?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },
  applicationRetirementProcessDecision: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}application-retirement/processDecision`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },
  getApplicationRetirementPendingCount: async () => {
    try {
      const response = await axios.get(`${API_ENDPOINT}application-retirement/approvals/pending/count`);
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },
  getMyPamPendingRequests: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}pam/safeManagement/pendingApprovals`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; 
    }
  },

  myPamRequestAction: async (formObject, reqNum, action) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}pam/safeManagement/${reqNum}/${action === 'Approve' ? 'approve' : 'reject'}`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; 
    }
  },

  requestAction: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}approval/submitApproval`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error requesting action:", error);
      throw error; // Re-throw to handle in components
    }
  },

  entraViewRequestDetails: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}entra/viewRequestDetails`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },

  appRegistrationViewRequestDetails: async (reqNum) => {
    try {
      const response = await axios.get(`${API_ENDPOINT}entra/app-registration/approvals/${reqNum}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },

  entraRequestAction: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}entra/approval/submit`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },

  getBusinessParams: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}approval/getBusinessParams`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },

  // SSO Pending Approvals
  getSSOPendingApprovals: async (formObject) => {
    try {
      const params = new URLSearchParams();
      if (formObject?.pagination?.page !== undefined) params.append('page', formObject.pagination.page);
      if (formObject?.pagination?.pageSize !== undefined) params.append('pageSize', formObject.pagination.pageSize);
      if (formObject?.searchFilter) params.append('searchFilter', formObject.searchFilter);
      if (formObject?.dateFilter?.startDate) params.append('startDate', formObject.dateFilter.startDate);
      if (formObject?.dateFilter?.endDate) params.append('endDate', formObject.dateFilter.endDate);
      
      const response = await axios.get(`${API_ENDPOINT}sso/approvals/pending?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching SSO pending approvals:", error);
      throw error;
    }
  },

  // SSO Approval Action (Approve/Reject)
  ssoRequestAction: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}sso/approvals/action`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error performing SSO approval action:", error);
      throw error;
    }
  },

  // SSO View Request Details
  ssoViewRequestDetails: async (requestNumber) => {
    try {
      const response = await axios.get(`${API_ENDPOINT}sso/approvals/${requestNumber}/details`);
      return response.data;
    } catch (error) {
      console.error("Error fetching SSO request details:", error);
      throw error;
    }
  },

  requestAction: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}approval/submitApproval`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error requesting action:", error);
      throw error; // Re-throw to handle in components
    }
  },

  // SSO Pending Approvals
  getSSOPendingApprovals: async (formObject) => {
    try {
      const params = new URLSearchParams();
      if (formObject?.pagination?.page !== undefined) params.append('page', formObject.pagination.page);
      if (formObject?.pagination?.pageSize !== undefined) params.append('pageSize', formObject.pagination.pageSize);
      if (formObject?.searchFilter) params.append('searchFilter', formObject.searchFilter);
      if (formObject?.dateFilter?.startDate) params.append('startDate', formObject.dateFilter.startDate);
      if (formObject?.dateFilter?.endDate) params.append('endDate', formObject.dateFilter.endDate);
      
      const response = await axios.get(`${API_ENDPOINT}sso/approvals/pending?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching SSO pending approvals:", error);
      throw error;
    }
  },

  // SSO Approval Action (Approve/Reject)
  ssoRequestAction: async (formObject) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}sso/approvals/decision`,        
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error performing SSO approval action:", error);
      throw error;
    }
  },

};

export default workflowService;
